import { giphyBlue, giphyDarkestGrey } from '@giphy/js-brand'
import { IGif } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import React, { useEffect, useState } from 'react'
import { channelGifs } from 'shared/api'
import Loader from 'shared/components/loaders/dots'
import useWindowSize from 'shared/hooks/window-size'
import styled from 'styled-components'
import Modal from './modal'

const MAX_ITEMS = 9
const CHANNEL_ID = 26187069
const ASPECT_RATIO = 16 / 9

const Container = styled.div`
    text-align: left;
`

const Title = styled.h2`
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    padding: 0 20px;
`

const Starter = styled.div`
    border-radius: 2px;
    margin-bottom: 10px;
    overflow: hidden;
`

const LoaderWrapper = styled.div`
    padding-top: 40px;
`

const Disclaimer = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: 4px;
    font-size: 15px;
    margin: 40px 20px 0;
    padding: 25px;
    position: relative;
    text-align: center;

    svg {
        left: 50%;
        position: absolute;
        top: 0;
        transform: translate(-50%, -30%);
    }

    p {
        margin: 0;
    }

    span {
        color: ${giphyBlue};
    }
`

const BackdropMakerStarters = () => {
    const [isFetching, setIsFetching] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)
    const [gifs, setGifs] = useState<IGif[]>([])
    const { innerWidth } = useWindowSize()

    useEffect(() => {
        const fetchStarters = async () => {
            setIsFetching(true)
            const { results = [] } = await channelGifs(CHANNEL_ID, MAX_ITEMS)
            if (results.length > MAX_ITEMS) {
                setGifs(results.slice(0, MAX_ITEMS))
            } else {
                setGifs(results)
            }
            setIsFetching(false)
        }
        fetchStarters()
    }, [])

    return (
        <Container>
            <Title>Browse Starters</Title>
            {isFetching ? (
                <LoaderWrapper>
                    <Loader />
                </LoaderWrapper>
            ) : (
                <>
                    {gifs.map(gif => (
                        <Starter key={gif.id}>
                            <Gif
                                gif={gif}
                                width={innerWidth}
                                height={innerWidth / ASPECT_RATIO}
                                onGifClick={() => setShowModal(true)}
                                noLink
                            />
                        </Starter>
                    ))}
                </>
            )}
            <Disclaimer>
                <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient x1="0%" y1="100%" x2="100%" y2="0%" id="computergradienticon">
                            <stop stopColor="#6157FF" offset="0%" />
                            <stop stopColor="#0CF" offset="100%" />
                        </linearGradient>
                        <path
                            d="M156.205 24a.466.466 0 00.342-.14.466.466 0 00.14-.343c0-.225-.097-.367-.291-.427l-4.021-2.021v-1.381h7.188c.396 0 .735-.14 1.016-.422.28-.28.421-.62.421-1.016V2.437c0-.396-.14-.735-.421-1.016-.28-.28-.62-.421-1.017-.421h-20.125c-.396 0-.735.14-1.016.421-.28.28-.421.62-.421 1.016V18.25c0 .397.14.736.421 1.016.28.281.62.422 1.017.422h7.187v1.38l-4.043 2.022c-.21.105-.3.285-.27.54.03.104.092.192.186.263a.484.484 0 00.297.107h13.41zm1.92-7.188h-17.25V3.876h17.25v12.938z"
                            id="computergradienticona"
                        />
                    </defs>
                    <g transform="translate(-138 -1)" fillRule="nonzero" fill="none">
                        <use fill="#F66" xlinkHref="#computergradienticona" />
                        <use fill="url(#computergradienticon)" xlinkHref="#computergradienticona" />
                    </g>
                </svg>
                <p>
                    Visit <span>GIPHY.com/create/backdrop</span> on your desktop computer to get started!
                </p>
            </Disclaimer>
            {showModal && <Modal onClose={() => setShowModal(false)} />}
        </Container>
    )
}

export default BackdropMakerStarters
